import type {
  SubmitPushToCardTransferError,
  TransferRail,
} from '@varo/graphql-schema-types';
import type { ReviewedTransfer } from 'features/feeBasedInstantTransfer/helpers/analyticsFormatters';
import { atom } from 'jotai';

// Outcome content stays in memory so a crafted link cannot inject copy, amounts, actions, or transfer details through URL params.
export type StoredOutcome<Content> = Content & { outcomeId: string };

export type SubmitServerError = Pick<
  SubmitPushToCardTransferError,
  'title' | 'message' | 'actions'
>;

export interface SubmitErrorContent {
  rail: TransferRail;
  errorReason: string;
  reviewed: ReviewedTransfer;
  serverError?: SubmitServerError;
}

export interface SubmitSuccessContent {
  rail: TransferRail;
  amount: string;
  transferSpeedMessage?: string;
}

export const submitErrorAtom = atom<StoredOutcome<SubmitErrorContent> | null>(
  null,
);

export const submitSuccessAtom =
  atom<StoredOutcome<SubmitSuccessContent> | null>(null);
